/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSeparator: {
  name: 'separator';
  data: string;
} = {
  name: 'separator',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 2A1.5 1.5 0 0 1 5 .5h6A1.5 1.5 0 0 1 12.5 2v1.5h2V3a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-.5h-2V14a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 14V7.5h-2V8a.5.5 0 0 1-1 0V3a.5.5 0 0 1 1 0v.5h2V2Zm-2 2.5v2h2v-2h-2Zm11 0h2v2h-2v-2Zm-1 2.5V4.5h-7v7h7V7Zm-7 5.5V14a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-1.5h-7Zm7-10.5v1.5h-7V2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
